export function roundNumber(x: number) {
    return Math.round(x * 10) / 10;
}